import { SharedProps } from '@/types'
import { usePage } from '@inertiajs/react'

export function useRole() {
  const { user_role, is_super_admin, current_organization } = usePage<SharedProps>().props

  return {
    isAtelier: user_role === 'atelier',
    isAccueil: user_role === 'accueil',
    isCourier: user_role === 'courier',
    isAdmin: user_role === 'admin' || !!is_super_admin,
    isSuperAdmin: !!is_super_admin,
    isBoutique: !!current_organization?.kind_store,
    isAtelierOrg: !!current_organization?.kind_atelier,
  }
}
